import Vue from 'vue'

export default Vue.component('edit-render', {
  name: 'editRender',
  functional: true,
  props: {
    crender: {
      type: Function,
      default: function () {}
    },
    value: {
      type: [Object, Number, String, Boolean, Array],
      default: function () {
        return {}
      }
    },
    row: {
      type: Object,
      default: function () {
        return {}
      }
    },
    col: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: [Number, String],
      default: 0
    }
  },
  render (h, self) {
    const { crender, value, row, col, index } = self.props
    let C = crender ? crender(h, { row, col, value, index }) : ''
    if (!C) {
      self.parent.showMode = false
    }
    return C
  }
})



// WEBPACK FOOTER //
// ./src/public/components/query-table/edit-render.js